import { Territory } from "..";
import { Lists } from "../../components";

export interface TerritoryReferralCount {
    territory: Territory;
    referralCount: number;
}

export interface StatusCount {
    status: string;
    count: number;
    listSlug?: Lists;
}

export interface TerritoryStatusCount extends StatusCount {
    territoryId: number;
}

export interface AdminDashboard {
    activeReferrals: TerritoryReferralCount[];
    donors: StatusCount[];
    tissues: StatusCount[];
    orders: StatusCount[];
    incomingOmars: TerritoryStatusCount[];
    currentMonthPlacementCount: number;
    previousMonthPlacementCount: number;
}

export const defaultAdminDashboard: AdminDashboard = {
    activeReferrals: [],
    donors: [],
    tissues: [],
    orders: [],
    incomingOmars: [],
    currentMonthPlacementCount: 0,
    previousMonthPlacementCount: 0,
};
